import styled from "styled-components";

export const IconComponentWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ArrayWrapper = styled.div`
  display: inline-flex;
  align-items: start;
  height: 100%;
`;

export const ArrayWrapperBlock = styled.div`
  align-items: start;
  height: 100%;
`;

export const ObjectWrapper = styled.div<{ isLinkedObject: boolean }>`
  display: inline-flex;
  align-items: ${(props) => (props.isLinkedObject ? "center" : "baseline")};
  height: 100%;
  marginleft: 16px;
`;

export const Values = styled.div`
  display: flex;
  flex-flow: column;
  padding-bottom: 4px;
`;

export const Title = styled.div`
  display: inline-flex;
  margin-right: 4px;
`;
